import {Action} from '../actions/pagesActions';
import {ActionType} from '../actionTypes';

export interface ErrorPagesDto {
    data?: any;
    elapsedTimeSecs?: number;
    finishTimestampUtc?: string;
    messageID?: number;
    severityLevel?: string;
    signature?: string;
    recommendedAction?: string;
    startTimestampUtc?: string;
    technicalMessage?: string;
    title?: string;
    userFriendlyMessage?: string;
}

export interface PagesState {
    data: any
    loading?: boolean;
    error?: ErrorPagesDto | any;
    type: string | null;
}

export class PagesStateInitialState implements PagesState {
    data = null;
    loading = false;
    type = null;
    error = null;
}

const initialState = new PagesStateInitialState();

const pagesReducer = (state: PagesState = initialState, action: Action) => {

    switch(action.type)
    {
        //delete a whole page
        case ActionType.DELETE_PAGE:
            return { ...state, loading: true, type: null };

        case ActionType.DELETE_PAGE_SUCCESS:
            return { ...state, data: action.payload, loading: false, type: action.type };

        case ActionType.DELETE_PAGE_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };
        //delete only image from page
        case ActionType.DELETE_PAGE_IMAGE:
            return { ...state, loading: true, type: null };

        case ActionType.DELETE_PAGE_IMAGE_SUCCESS:
            return { ...state, data: action.payload, loading: false, type: action.type };

        case ActionType.DELETE_PAGE_IMAGE_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };

        case ActionType.INSERT_PAGE:
            return { ...state, loading: true, type: null };

        case ActionType.INSERT_PAGE_SUCCESS:
            return { ...state, data: action.payload, loading: false, type: action.type };

        case ActionType.INSERT_PAGE_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };

        case ActionType.MOVE_PAGES_BEFORE:
            return { ...state, loading: true, type: null };

        case ActionType.MOVE_PAGES_BEFORE_SUCCESS:
            return { ...state, data: action.payload, loading: false, type: action.type };

        case ActionType.MOVE_PAGES_BEFORE_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };

        case ActionType.UPLOAD_IMAGES_TO_PAGES:
            return { ...state, loading: true, type: null };

        case ActionType.UPLOAD_IMAGES_TO_PAGES_SUCCESS:
            return { ...state, loading: false, type: action.type };
            // return { ...state, data: action.payload, loading: false, type: action.type };

        case ActionType.UPLOAD_IMAGES_TO_PAGES_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };

        case ActionType.CHANGE_QUALIFICATION_STATUS_FOR_PAGES_START:
            return { ...initialState, loading: true, type: action.type };
        case ActionType.CHANGE_QUALIFICATION_STATUS_FOR_PAGES_SUCCESS:
            return { ...state, data: action.payload, error: null, loading: false, type: action.type };
        case ActionType.CHANGE_QUALIFICATION_STATUS_FOR_PAGES_COMPLETE:
            return { ...state, error: null, loading: false, type: action.type };
        case ActionType.CHANGE_QUALIFICATION_STATUS_FOR_PAGES_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };
        default:
            return state;
    }
}

export default pagesReducer;